import { __module as slicedToArray } from '../../../../_virtual/slicedToArray.js';
import './arrayWithHoles.js';
import './iterableToArrayLimit.js';
import './unsupportedIterableToArray.js';
import './nonIterableRest.js';
import { exports as arrayWithHolesExports } from '../../../../_virtual/arrayWithHoles.js';
import { exports as iterableToArrayLimitExports } from '../../../../_virtual/iterableToArrayLimit.js';
import { exports as unsupportedIterableToArrayExports } from '../../../../_virtual/unsupportedIterableToArray.js';
import { exports as nonIterableRestExports } from '../../../../_virtual/nonIterableRest.js';

(function (module) {
	var arrayWithHoles = arrayWithHolesExports;
	var iterableToArrayLimit = iterableToArrayLimitExports;
	var unsupportedIterableToArray = unsupportedIterableToArrayExports;
	var nonIterableRest = nonIterableRestExports;
	function _slicedToArray(r, e) {
	  return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
	}
	module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (slicedToArray));
//# sourceMappingURL=slicedToArray.js.map
